import { Segment } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { FilterOptions } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/bulk.pb';
import { SegmentSelectionForm } from '../segment-selection-form/segment-selection-form';
import { SegmentsList } from '../segments-list/segments-list';
import { TrayMode } from '../types';

type Props = {
  campaignId: string;
  filters: FilterOptions;
  handleDraftConversion: () => Promise<void>;
  isCreatingSegment: boolean;
  locationIds: string[];
  mode: TrayMode;
  segments?: Segment[];
  setFilters: (filters: FilterOptions) => void;
  setMode: (mode: TrayMode) => void;
  trackingIdPrefix: string;
};

export const SegmentsModalContent = ({
  campaignId,
  filters,
  handleDraftConversion,
  isCreatingSegment,
  locationIds,
  mode,
  segments,
  setFilters,
  setMode,
  trackingIdPrefix,
}: Props) => (
  <div css={{ height: '100%' }}>
    {mode === 'form' ? (
      <SegmentSelectionForm
        filters={filters}
        locationIds={locationIds}
        setFilters={setFilters}
        trackingIdPrefix={trackingIdPrefix}
      />
    ) : (
      <SegmentsList
        campaignId={campaignId}
        handleDraftConversion={handleDraftConversion}
        isCreatingSegment={isCreatingSegment}
        locationIds={locationIds}
        segments={segments}
        setFilters={setFilters}
        setMode={setMode}
        trackingIdPrefix={trackingIdPrefix}
      />
    )}
  </div>
);
